export const ANALYTICS_EVENTS = {
  LOGIN_ATTEMPTED: 'login_attempted',
  LOGIN_FAILED: 'login_failed',
  LOGIN_SUCCEEDED: 'login_succeeded',
  PASSWORD_RESET_REQUESTED: 'password_reset_requested',
  PASSWORD_RESET_COMPLETED: 'password_reset_completed',
  FUND_FORM_STARTED: 'fund_form_started',
  FUND_FORM_FIELD_ERROR: 'fund_form_field_error',
  FUND_FORM_ABANDONED: 'fund_form_abandoned',
  FUND_FORM_SUBMITTED: 'fund_form_submitted',
  FUND_FORM_LEAD_CAPTURED: 'fund_form_lead_captured',
  /** Personal-area support-request funnel (SPR-1206 B). */
  SUPPORT_REQUEST_STARTED: 'support_request_started',
  SUPPORT_REQUEST_ABANDONED: 'support_request_abandoned',
  SUPPORT_REQUEST_SUBMITTED: 'support_request_submitted',
  TRANSACTIONS_FILTER_USED: 'transactions_filter_used',
  TRANSACTIONS_EXPORT_CLICKED: 'transactions_export_clicked',
  TRANSACTIONS_EMPTY_STATE_SHOWN: 'transactions_empty_state_shown',
} as const;

export type LoginFailureReason =
  | 'wrong_password'
  | 'email_not_found'
  | 'too_many_attempts'
  | 'network'
  | 'server'
  | 'generic';
